<!-- 取消预定车位 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNTYVWC",
                "orderSeq": "123456",
                "carCode": "粤TEST01",
                "refundMoney": 10.00,
                "cancelReasonType":2,
                "operateTime": "2017-11-07 00:00:00",
                "operator": "admin123"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台取消车位预订",
                t_url: this.commonUrls.test+"cancelBookingSpace",
                p_url: this.commonUrls.prod+"cancelBookingSpace",
                precondition: "VEMS 2.13及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'orderSeq', info2: 'orderSeq和carCode不能为空,优先使用orderSeq', info3: 'String', info4: '订单编号' },
                        { info1: 'carCode', info2: 'orderSeq和carCode不能为空,优先使用orderSeq', info3: 'String', info4: '预订车牌' },
                        { info1: 'refundMoney', info2: '是', info3: 'decimal', info4: '退款金额' },
                        { info1: 'cancelReasonType', info2: '是', info3: 'decimal', info4: '退款原因，2车主取消，3后台取消，4自动取消' },
                        { info1: 'operator', info2: '是', info3: 'String', info4: '操作人' },
                        { info1: 'operateTime', info2: '是', info3: 'String', info4: '操作时间' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/shareBooking/cancelBookingSpace.vue